"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldType = void 0;
var tslib_1 = require("tslib");
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var FormFieldInputType_1 = require("./FormFieldInputType");
var FormFieldMetaType_1 = require("./FormFieldMetaType");
exports.FormFieldType = prop_types_1.default.shape({
    input: FormFieldInputType_1.FormFieldInputType,
    meta: FormFieldMetaType_1.FormFieldMetaType,
});
//# sourceMappingURL=FormFieldType.js.map